import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import template from './rejection-type-column.pug';

export class RejectionTypeColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, recommendationType }) {
    super({
      name: 'RejectionType',
      property: 'Opportunities/RejectionType',
      title: i18n.getString('Details_View_Rejection_Type'),
      bodyClasses: ['grid-column-rejectionType'],
      colClasses: ['col-longText'],
      helpId: 'Pop_BA_Recommendations_IssueType',
      type: 'string',
    });
    this.i18n = i18n;
    this.recommendationType = recommendationType;
  }

  template({
    value: {
      FlagId,
    },
  }) {
    const { i18n } = this;

    return template({
      rejectionType: this.i18n.getString(`Details_View_Rejection_Type_${FlagId}`),
      i18n,
    });
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
